export type PagingMode = 'limited' | 'infinite';

export type MobileDisplayMode = 'cards' | 'moreInformation';
export type DesktopDisplayMode = MobileDisplayMode | 'largeCards';

/**
 * enum to map the different internal display modes to their respective GTM tracking values.
 * These values must only be used for the display mode change GTM tracking.
 */
export enum DisplayModeEnum {
  cards = 'galerie_4_spaltig',
  largeCards = 'galerie_3_spaltig',
  moreInformation = 'liste',
}

export type FilterRangeValue = {
  unit: string;
  range: [number | undefined, number | undefined];
};

export type SelectedFilterValue = {
  filterId: string;
  selectedRange?: FilterRangeValue;
  selectedValues: string[];
};
